$(function() {
    $('.js-form-contest').validate({
        errorPlacement: function(error, element) {
            if (element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function(form) {
            Form.ajaxPost(form, function(data) {    
                $('.js-contest-error').slideUp();

                if (!data.status) {
                    $('.js-contest-error').text(data.message).slideDown();
                } else {
                    $('.js-contest-hide').fadeOut(250, function(){
                        $('.js-contest-success').removeClass('is-hidden');
                    });
                }

                Event.dispatch("Recaptcha.execute");
            }, "json");
        }
    });
});